import React, { Fragment, useEffect, useState } from "react";
import { getEmissionListService } from "../../services/emissionService";
import "./PendingApprovals.scss";
import { minPageLimit } from "../../constants/config";
import { checkPermissions, dateParser, parseDateMonth } from "../../helper";
import { useSelector } from "react-redux";
import { CaretDownOutlined } from "@ant-design/icons";
import { Select as AntSelect } from "antd";
import EmissionStatusUpdate from "../EmissionLog/EmissionApprovalManagement/EmissionStatusUpdate";
import { EMISSION_DATA_STATUS_TYPE, STEPS } from "../../constants/enums";
import { Box, FormControl } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CardSkeleton from "../common/Skeletons/CardSkeleton/CardSkeleton";

const PendingApprovals = (props: any) => {
  const { type } = props;
  const { Option } = AntSelect;
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const navigate = useNavigate();
  const convertRemToPixels = (rem: any) => {
    return (
      rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
    );
  };
  const [pendingEmissions, setPendingEmissions] = useState<any>([]);
  const [statusFilter, setStatusFilter] = useState("Pending");
  const currentBusinessUnit = useSelector(
    (state: any) => state.auth.currentBusinessUnit
  );
  const [statusOptions, setStatusOptions] = useState<any>({
    Pending: ["Approved", "Rejected"],
    Approved: ["Rejected"],
  });
  const [eachEmissionData, setEachEmissionData] = useState({} as any);
  const [updateStatusFormData, setUpdateStatusFormData] = useState({
    comments: "",
    attachments: [],
  });
  const [openUpdate, setOpenUpdate] = useState(false);
  const [showPrevButton, setShowPrevButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const [emissionsCount, setemissionsCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [controller, setController] = useState({
    page: 0,
    limit: minPageLimit,
  });
  const getEmissionData = () => {
    const reqObj: any = {
      controller: controller,
      type: props.type,
    };
    reqObj["statusFilter"] = statusFilter;
    localStorage.getItem("currentBusinessUnit") &&
    JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id
      ? getEmissionListService(reqObj)
          .then((res: any) => {
            let emissionList: any = res.data.emissionsList;
            setPendingEmissions([...pendingEmissions, ...emissionList]);
            setemissionsCount(res.data.total_count || 0);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setIsLoading(false);
          })
      : setIsLoading(false);
  };

  useEffect(() => {
    setController({
      page: 0,
      limit: minPageLimit,
    });
    setemissionsCount(0);
    setPendingEmissions([]);
    // getEmissionData();
  }, [currentBusinessUnit]);

  useEffect(() => {
    getEmissionData();
  }, [controller]);

  const handleNextScroll = () => {
    const scrollContainer = document.querySelector(
      props.type === "Category" ? ".pw-scroll-Category" : ".pw-scroll-Asset"
    );
    if (scrollContainer) {
      const newScrollPosition = scrollContainer.scrollLeft;
      setShowNextButton(true);
      setShowPrevButton(newScrollPosition > 0);
    }
  };

  const handleNextPage = () => {
    const scrollContainer = document.querySelector(
      props.type === "Category" ? ".pw-scroll-Category" : ".pw-scroll-Asset"
    );
    if (scrollContainer) {
      const newScrollPosition =
        scrollContainer.scrollLeft + convertRemToPixels(50);
      scrollContainer.scrollTo({
        left: newScrollPosition,
        behavior: "smooth",
      });
      pendingEmissions?.length === emissionsCount &&
        setShowNextButton(
          scrollContainer.scrollWidth - convertRemToPixels(40) >
            newScrollPosition
        );
      setShowPrevButton(true);
      if (
        newScrollPosition >
        scrollContainer.scrollWidth - convertRemToPixels(40)
      ) {
        if (Math.ceil(emissionsCount / 10) > controller.page + 1) {
          setController((prevController) => ({
            ...prevController,
            page: prevController.page + 1,
          }));
        }
      }
    }
  };

  const handlePreviousPage = () => {
    const scrollContainer = document.querySelector(
      props.type === "Category" ? ".pw-scroll-Category" : ".pw-scroll-Asset"
    );
    if (scrollContainer) {
      const newScrollPosition =
        scrollContainer.scrollLeft - convertRemToPixels(40);
      scrollContainer.scrollTo({
        left: newScrollPosition,
        behavior: "smooth",
      });
      setShowNextButton(true);
      setShowPrevButton(newScrollPosition > 0);
    }
  };
  const handleStatusChange = (e: any, index: any, each: any, from?: any) => {
    const updatedStatus = pendingEmissions;
    setEachEmissionData({ ...each, toStatus: e || "", index, from });
    setPendingEmissions([...updatedStatus]);
    setOpenUpdate(true);
  };
  return (
    <Fragment>
      {isLoading ? (
        <CardSkeleton type="text" count={8} />
      ) : (
        <>
          <div className="flex flex-col justify-between ">
            <div className="flex flex-row justify-between">
              <div className="text-black text-sm font-bold font-['Proxima Nova']">
                Pending approvals (
                {props.type === "Category" ? "Facility" : "Asset"})
              </div>
              {pendingEmissions?.length > 4 && (
                <div
                  className="text-green-400 text-sm font-['Proxima Nova'] cursor-pointer"
                  // onClick={() => navigate("/log/Emissions")}
                  onClick={() => {
                    navigate("/log/emissions", {
                      state: {
                        from:
                          props.type === "Category"
                            ? STEPS.CATEGORYWISE
                            : STEPS.ASSETS,
                      },
                    });
                  }}
                >
                  View all
                </div>
              )}
            </div>
            {pendingEmissions?.length ? (
              <div className="flex flex-row py-4">
                {showPrevButton && pendingEmissions?.length > 3 ? (
                  <button
                    onClick={handlePreviousPage}
                    // disabled={controller.page === 0}
                    className="pw-left-arrow"
                  >
                    <img
                      src="assets/icons/arrow-left.svg"
                      alt=" "
                      className="pw-arrow"
                    />
                  </button>
                ) : (
                  ""
                )}
                <div
                  className={`pw-scroll-${type} flex flex-row gap-4 overflow-x-auto`}
                  onScroll={() => handleNextScroll()}
                >
                  {pendingEmissions.map((eachEmission: any, index: number) => (
                    <div
                      key={eachEmission.id}
                      className="w-72 h-52 p-4 bg-white rounded-lg flex-col justify-start items-start gap-4 inline-flex"
                    >
                      <div className="w-64  h-12 max-h-12 text-neutral-800 text-sm font-medium font-['Proxima Nova']">
                        {eachEmission.code +
                          " " +
                          eachEmission.category +
                          " - " +
                          eachEmission.id}
                      </div>
                      <div className="self-stretch justify-start items-center gap-2 inline-flex">
                        <div className="text-neutral-800 text-sm font-bold font-['Proxima Nova']">
                          {eachEmission.value
                            ? parseFloat(eachEmission.value).toFixed(2)
                            : 0}{" "}
                          kgCO2e
                        </div>
                        <div className="text-neutral-800 text-sm font-normal font-['Proxima Nova'] leading-tight">
                          ({parseDateMonth(eachEmission.from_date) || "-"})
                        </div>
                      </div>
                      <div className="justify-start items-center gap-1 inline-flex">
                        <img
                          className="w-6 h-6 relative rounded-3xl"
                          src={
                            eachEmission.ownerProfileImageUrl
                              ? eachEmission.ownerProfileImageUrl
                              : "assets/images/AvatarEmpty.png"
                          }
                          alt="User"
                        />
                        <div className="text-neutral-800 text-sm font-bold font-['Proxima Nova']">
                          {eachEmission.ownerDisplayName}
                        </div>
                      </div>
                      <div className="self-stretch justify-between items-center inline-flex">
                        <div className="w-20 justify-start items-start flex">
                          <p
                            className={`text-success text-sm pw-status-dropdown-${eachEmission?.status} font-bold`}
                          >
                            {eachEmission?.status ===
                              EMISSION_DATA_STATUS_TYPE.REJECTED ||
                            !(eachEmission?.status ===
                            EMISSION_DATA_STATUS_TYPE.APPROVED
                              ? checkPermissions(
                                  ["UPDATE_APPROVED_EMISSIONS"],
                                  permissions
                                )
                              : checkPermissions(
                                  ["UPDATE_EMISSION_STATUS"],
                                  permissions
                                )) ? (
                              <div
                                className={`pw-${eachEmission?.status?.toLowerCase()}-option pw-status-option-btn font-bold pw-bg-primary-200`}
                              >
                                {eachEmission?.status}
                              </div>
                            ) : (
                              <Box>
                                <FormControl
                                  fullWidth
                                  size="small"
                                  className="pw-form-select"
                                >
                                  <AntSelect
                                    dropdownStyle={{
                                      minWidth: "8rem",
                                      paddingRight: "12px",
                                    }}
                                    suffixIcon={
                                      <CaretDownOutlined className="!pointer-events-none" />
                                    }
                                    value={eachEmission?.status}
                                    className="pw-status-selection"
                                    onChange={(event: any) => {
                                      handleStatusChange(
                                        event,
                                        index,
                                        eachEmission
                                      );
                                    }}
                                  >
                                    {statusOptions[eachEmission?.status]?.map(
                                      (name: any, index: number) => {
                                        return (
                                          <Option
                                            value={name}
                                            // className={`pw-${name?.toLowerCase()}-option  pw-margin-10 pw-status-option-btn font-bold pw-bg-primary-200`}
                                            className={` pw-margin-10 font-bold pw-${name.toLowerCase()}-option`}
                                          >
                                            {name}
                                          </Option>
                                        );
                                      }
                                    )}
                                  </AntSelect>
                                </FormControl>
                              </Box>
                            )}
                          </p>
                        </div>
                        <div className="text-slate-500 text-xs font-normal font-['Proxima Nova'] leading-none">
                          {(eachEmission.last_updated && (
                            <p>
                              {eachEmission.last_updated &&
                                dateParser(eachEmission.last_updated)}
                            </p>
                          )) ||
                            "-"}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {showNextButton && pendingEmissions?.length > 3 ? (
                  <button
                    onClick={handleNextPage}
                    // disabled={pendingEmissions.length < controller.limit}
                    className="pw-right-arrow"
                  >
                    <img
                      src="assets/icons/arrow-right-home-page.svg"
                      alt=" "
                      className="pw-arrow"
                    />
                  </button>
                ) : (
                  ""
                )}
                {openUpdate && (
                  <EmissionStatusUpdate
                    setEachEmissionData={setEachEmissionData}
                    eachEmissionData={eachEmissionData}
                    setemissionsList={setPendingEmissions}
                    emissionList={pendingEmissions}
                    updateStatusFormData={updateStatusFormData}
                    setUpdateStatusFormData={setUpdateStatusFormData}
                    setOpenUpdate={setOpenUpdate}
                  />
                )}
              </div>
            ) : (
              ""
            )}
          </div>
          {!pendingEmissions?.length && (
            <div className="flex flex-row p-4">
              <div className="w-full h-20 bg-slate-200 justify-center items-center inline-flex">
                <div className="text-slate-500 text-sm font-medium font-['Proxima Nova']">
                  Any pending approvals will be displayed here
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </Fragment>
  );
};

export default PendingApprovals;
